import { Component, forwardRef, Input, Optional, OnInit } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EyBaseFormControlComponent } from '../ey-base-form-control/ey-base-form-control';
import { DEFAULT_MAX_RATING, DEFAULT_RATING_TYPE, RATING_TYPES } from '../ey-rating/ey-display-rating/ey-display-rating.component';

@Component({
  standalone: false,
  selector: 'ey-rating',
  templateUrl: './ey-rating.component.html',
  styleUrls: ['./ey-rating.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EyRatingComponent),
      multi: true,
    },
  ],
})
export class EyRatingComponent extends EyBaseFormControlComponent implements ControlValueAccessor, OnInit {
  @Input() disableErrorEvaluation = false;
  @Input() warning = false;
  @Input() noErrorLabel = false;
  @Input() isDisabled = false;
  @Input() changeErrorDisplayPositionForLongMessages = false;
  @Input() maxRating = DEFAULT_MAX_RATING;
  @Input() ratingType: RATING_TYPES = DEFAULT_RATING_TYPE;
  @Input() ratingValue: number;
  @Input() decreaseRatingSize = false;

  selectedRating: number;

  constructor(@Optional() controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void {
    this.selectedRating = this.ratingValue;
  }

  onChange = (value: number) => {};
  onTouched = (value: number) => {};

  onRating(number: any): void {
    this.selectedRating = number;
    this.onChange(this.selectedRating);
    this.onBlur();
  }

  onBlur(): void {
    this.onTouched(this.selectedRating);
  }

  writeValue(initValue: any): void {
    this.selectedRating = initValue;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
